import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

export const renderMuiTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={ label }
    placeholder={ label }
    error={ touched && invalid }
    helperText={ touched && error }
    { ...input }
    { ...custom }
  />
);

renderMuiTextField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  })
};

export const renderMuiSelectField = ({
  input,
  label,
  children,
  ...custom
}) => (
  <Select
    { ...input }
    { ...custom }
    inputProps={{
      name: input.name,
      id: `select-input-${ input.name }`
    }}
  >
    { children }
  </Select>
);

renderMuiSelectField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  children: PropTypes.any
};

export const renderMuiCheckbox = ({ input, label }) => (
  <div>
    <FormControlLabel
      control={ <Checkbox
        color="primary"
        checked={ Boolean(input.value) }
        onChange={ input.onChange }
      /> }
      label={ label }
    />
  </div>
);

renderMuiCheckbox.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
};
